<template>
  <v-container class="preview-section">
    <v-row align="center" justify="center">
      <h1 class="preview-title text-center">Join Our Exclusive Preview!</h1>
    </v-row>

    <v-row align="center" justify="center">
      <!-- Image Card -->
      <v-col cols="12" md="7">
        <v-card class="preview-image-card">
          <v-img src="@/assets/6_Showflat.jpg" alt="Preview Image" height="300px" cover></v-img>
        </v-card>
      </v-col>

      <!-- Text Content -->
      <v-col cols="12" md="5" class="text-center">
        
        <p class="preview-description">
          Be among the first to experience Arina East Residences at our exclusive preview launch. Discover thoughtfully designed freehold homes, premium amenities, and seamless connectivity just 3 minutes from Katong Park MRT. With proximity to top schools, lifestyle hubs, and East Coast Park, this city-fringe gem offers the perfect blend of luxury and convenience. Don’t miss your chance to secure your dream home at pre-launch prices!
        </p>
        <v-btn color="primary" class="preview-button" @click="scrollToSection('enquire')">
          Join Our VVIP Preview
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AboutView',
  props: {
    scrollToSection: Function, // Define the prop to accept the method
  },
});
</script>

<style scoped>
.preview-section {
  background-color: #F7F4ED;
  padding: 60px 20px;
  border-radius: 12px;
  max-width: 1000px;
  margin: auto;
}

.preview-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 20px;
}

.preview-description {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 32px;
}

.preview-button {
  font-size: 1rem;
  font-weight: bold;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.preview-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.preview-image-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
  .preview-title {
    font-size: 2rem;
  }

  .preview-description {
    font-size: 1rem;
  }

  .preview-button {
    font-size: 0.9rem;
    padding: 10px 20px;
  }
}
</style>
